import { registerApi as api } from '../../api';

export const uploadSalaryRegister = async (fileData) => {
    try {
        const formData = new FormData();
        formData.append('file', fileData);
        const token = sessionStorage.getItem('token');
        const selectedClientID = sessionStorage.getItem('selectedClient')
        const response = await api.post('/upload_salary_register', formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            },
            params : {
                'selectedClientID' : selectedClientID
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

export const fetchSalaryRegister = async (current_month) => {
    const month = String(current_month || "").trim();
    if (!/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(month) || month.includes("NaN")) {
        throw "A valid payroll month is required (YYYY-MM-DD).";
    }
    try {
        const client_ID = sessionStorage.getItem('selectedClient')
        const response = await api.get(`/get_salary_register/${month}`,
            {
                params: {
                    client_id: client_ID
                }
            }
        );
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

export const updateSalaryRegister = async (id, salaryData) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.put(`/update_salary_register/${id}`, salaryData, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
export const deleteSalaryRegister = async (id) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.delete(`/delete_salary_register/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message
    }
}
export const multiDeleteSalaryRegister = async (ids) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.post('/delete_multiple_salary_register', ids, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        console.log(response.data);
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
